import { render, staticRenderFns } from "./EEscolhaMesPlanoSemanal.vue?vue&type=template&id=3b552ce5"
import script from "./EEscolhaMesPlanoSemanal.vue?vue&type=script&lang=js"
export * from "./EEscolhaMesPlanoSemanal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports